// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: linear-gradient(135deg, #1A1A1A 0%, #2A2A2A 100%);
  color: var(--white);
  padding: 80px 0 0;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.5fr;
  gap: 64px;
  padding-bottom: 56px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer-logo {
  margin-bottom: 8px;
}

.footer-description {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 1.8;
  max-width: 350px;
}

.footer-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--white);
  margin-bottom: 4px;
}

.footer-links {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  transition: var(--transition);
  display: inline-block;
}

.footer-links a:hover {
  color: var(--secondary-color);
  transform: translateX(4px);
}

.footer-info {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-info li {
  display: flex;
  align-items: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.footer-info svg {
  flex-shrink: 0;
  color: var(--primary-color);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

.footer-legal {
  display: flex;
  gap: 12px;
  align-items: center;
}

.footer-legal a {
  color: rgba(255, 255, 255, 0.6);
  transition: var(--transition);
}

.footer-legal a:hover {
  color: var(--white);
}

.footer-legal span {
  color: rgba(255, 255, 255, 0.3);
}

@media (max-width: 968px) {
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }
}

@media (max-width: 640px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;AACF","sourcesContent":[".footer {\n  background: linear-gradient(135deg, #1A1A1A 0%, #2A2A2A 100%);\n  color: var(--white);\n  padding: 80px 0 0;\n  margin-top: auto;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.footer-content {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1.5fr;\n  gap: 64px;\n  padding-bottom: 56px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.footer-section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.footer-logo {\n  margin-bottom: 8px;\n}\n\n.footer-description {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n  line-height: 1.8;\n  max-width: 350px;\n}\n\n.footer-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--white);\n  margin-bottom: 4px;\n}\n\n.footer-links {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.footer-links a {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n  transition: var(--transition);\n  display: inline-block;\n}\n\n.footer-links a:hover {\n  color: var(--secondary-color);\n  transform: translateX(4px);\n}\n\n.footer-info {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.footer-info li {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 14px;\n}\n\n.footer-info svg {\n  flex-shrink: 0;\n  color: var(--primary-color);\n}\n\n.footer-bottom {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px 0;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.footer-legal {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.footer-legal a {\n  color: rgba(255, 255, 255, 0.6);\n  transition: var(--transition);\n}\n\n.footer-legal a:hover {\n  color: var(--white);\n}\n\n.footer-legal span {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n@media (max-width: 968px) {\n  .footer-content {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 40px;\n  }\n}\n\n@media (max-width: 640px) {\n  .footer-content {\n    grid-template-columns: 1fr;\n    gap: 40px;\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
